import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import routes from "./routes";
import DefaultLayout from "./layout/DefaultLayout";
import PageTitle from "./layout/PageTitle";
import { logo } from "./assets";
import { BusinessContextProvider } from "./context/BusinessContext";
import PublicRoute from "./components/PublicRoute";
import PermissionRoute from "./components/PermissionRoute";
import { SocketContextProvider } from "./context/SocketContext";
import { NotificationContextProvider } from "./context/NotificationContext";
import NotFound from "./pages/NotFound";
import WelcomeLayout from "./layout/WelcomeLayout";
import OnboardingScreen from "./pages/DashboardComponents/OnboardingScreen";

function App() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="h-screen w-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f1f5f9' fill-opacity='0.4'%3E%3Ccircle cx='30' cy='30' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
            }}></div>
            
            <div className="text-center z-10">
              <div className="relative mb-8">
                <div className="absolute -inset-4 bg-gradient-to-r from-primary/20 to-secondary/20 rounded-full blur-xl animate-pulse"></div>
                <div className="relative bg-primary p-6 rounded-2xl shadow-2xl border border-gray-200/50 backdrop-blur-sm">
                  <img
                    src={logo}
                    className="w-20 h-16 mx-auto object-contain"
                    alt="ZApp Logo"
                  />
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="flex justify-center">
                  <div className="flex space-x-1">
                    {[0, 1, 2].map((i) => (
                      <div
                        key={i}
                        className="w-3 h-3 bg-primary rounded-full animate-bounce"
                        style={{
                          animationDelay: `${i * 0.15}s`,
                          animationDuration: "0.8s"
                        }}
                      />
                    ))}
                  </div>
                </div>
                
                <div className="space-y-2">
                  <h2 className="text-2xl font-semibold text-gray-800 animate-pulse">
                    ZApp Merchant
                  </h2>
                  <p className="text-gray-500 text-sm font-medium">
                    Preparing your experience...
                  </p>
                </div>
              </div>
              
              <div className="mt-8 w-64 mx-auto">
                <div className="h-1 bg-gray-200 rounded-full overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-primary to-secondary rounded-full animate-pulse"></div>
                </div>
              </div>
            </div>
            
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
              <p className="text-xs text-gray-400 font-medium">
                Powered by Zahra Group Holding
              </p>
            </div>
          </div>
        }
      >
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                route.isProtected ? (
                  <BusinessContextProvider>
                    <NotificationContextProvider>
                      <SocketContextProvider>
                        <DefaultLayout>
                          <PageTitle title={"ZApp | " + route.title} />
                          {route.permission ? (
                            <PermissionRoute permission={route.permission}>
                              {route.element}
                            </PermissionRoute>
                          ) : route.element}
                        </DefaultLayout>
                      </SocketContextProvider>
                    </NotificationContextProvider>
                  </BusinessContextProvider>
                ) : (
                  <>
                    <PublicRoute>
                      <PageTitle title={"ZApp | " + route.title} />
                      {route.element}
                    </PublicRoute>
                  </>
                )
              }
            />
          ))}          <Route
            path="/welcome"
            element={
              <WelcomeLayout>
                <OnboardingScreen />
              </WelcomeLayout>
            }
          />
          <Route path="*" element={<NotFound />} />        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
